import { compose, lifecycle, withState } from 'recompose';

import PushApiLog from '../components/PushApiLog';
import { createSocket } from '../../../../utils/socket';

const configureSocket = props => {
  const socket = createSocket('tasks');

  socket.on('pushEvent', event => {
    if (event && props.api && event.api === props.api._id) {
      props.setPushEvent(event);
    }
  });

  props.setSocket(socket);
};

const enhance = compose(
  withState('socket', 'setSocket', null),
  withState('pushEvent', 'setPushEvent', null),
  lifecycle({
    componentDidMount() {
      configureSocket(this.props);
    },
    componentWillUnmount() {
      try {
        this.props.socket.close();
      } catch (err) {}
    },
  })
);

export default enhance(PushApiLog);
